export const SERVER_URL = "http://localhost:8000";
export const PAYSTACK_PUBLIC_KEY = "pk_live_c88e4b2ec2f46c0df24cd4a3aae630b54d376ea6";
// export const PAYSTACK_PUBLIC_KEY = "pk_test_c92dec784d8548ece123ebd0573354e01ce738bc";

export const PERMISSIONS = {
    patient: ["PATIENT"],
    doctor: ["SPECIALIST"],
    both: ["PATIENT", "SPECIALIST"]
}

export const MEDIA_SERVER = "https://evoke-storage-system.fra1.cdn.digitaloceanspaces.com/evoke-storage-system/media/";
export const ACCESS_PAGE = "Application_Access_Page";
export const APPS_NAME = {
	MEDICAL_PROFILE: "MEDICAL-PROFILE",
	PRESCRIPTION: "PRESCRIPTION",
	RECOMMENDATIONS: "RECOMMENDATIONS",
	APPOINTMENTS: "APPOINTMENT",
}
export const ACCESS_PERMISSIONS = [
	APPS_NAME.MEDICAL_PROFILE,
	// APPS_NAME.PRESCRIPTION,
	// APPS_NAME.RECOMMENDATIONS,
	// APPS_NAME.APPOINTMENTS,
];